declare var _gaq: any;

export class Carousel {
    private activeImageId: number;
    private imageCount: number;
    private interval: any;

    constructor() {
        const images: NodeListOf<HTMLElement> = document.querySelectorAll("[data-image-id]") as NodeListOf<HTMLElement>;

        if (images.length > 0) {
            this.activeImageId = 0;
            this.showActiveImage();
            if (images.length > 1) {
                this.bindInteractions();
                this.startAutoPlay();
            }
        }
    }

    private bindInteractions() {
        this.bindThumbnailAction();
        this.bindNavigateAction();
    }

    private showActiveImage() {
        const images: NodeListOf<HTMLElement> = document.querySelectorAll("[data-image-id]") as NodeListOf<HTMLElement>;
        const thumbs: NodeListOf<HTMLElement> = document.querySelectorAll("[data-thumb-id]") as NodeListOf<HTMLElement>;

        for (let i = 0; i < images.length; i++) {
            const image: HTMLElement = document.querySelector(`[data-image-id="${i}"]`) as HTMLElement;
            const thumb: HTMLElement = document.querySelector(`[data-thumb-id="${i}"]`) as HTMLElement;
            const imageId: number = parseInt(image.getAttribute("data-image-id"), 10);
            const imageSrc: string = image.getAttribute("data-src");
            if (imageId === this.activeImageId) {
                image.style.backgroundImage = `url("${imageSrc}")`;            
                image.classList.add("active");
                if (images.length > 1) {
                    thumb.classList.add("active");
                }
            } else {
                image.classList.remove("active");
                thumb.classList.remove("active");              
            }
        }
    }

    private bindThumbnailAction() {
        const thumbs: NodeListOf<HTMLElement> = document.querySelectorAll("[data-thumb-id]") as NodeListOf<HTMLElement>;

        for (let i = 0; i < thumbs.length; i++) {
            const thumb: HTMLElement = document.querySelector(`[data-thumb-id="${i}"]`) as HTMLElement;
            thumb.addEventListener("click", () => {
                const thumbId: number = parseInt(thumb.getAttribute("data-thumb-id"), 10);
                this.activeImageId = thumbId;
                this.showActiveImage();
                _gaq.push(["_trackEvent", "Interaction", `Image carousel interaction THUMBNAIL (${thumbId})`, document.URL, 0, false]);
            });

            thumb.addEventListener("mouseenter", () => {
                clearInterval(this.interval);
            });

            thumb.addEventListener("mouseleave", () => {
                this.startAutoPlay();
            });
        }

        this.imageCount = thumbs.length;
    }

    private bindNavigateAction() {
        const prev: HTMLElement = document.querySelector("[data-carousel-left]") as HTMLElement;
        const next: HTMLElement = document.querySelector("[data-carousel-right]") as HTMLElement;

        prev.addEventListener("click", () => {
            clearInterval(this.interval);

            this.activeImageId -= 1;
            if (this.activeImageId < 0) {
                this.activeImageId = this.imageCount - 1;
            }

            this.makeImageActive(this.activeImageId);
            this.startAutoPlay();
            _gaq.push(["_trackEvent", "Interaction", `Image carousel interaction PREV (${this.activeImageId})`, document.URL, 0, false]);
        });

        next.addEventListener("click", () => {
            clearInterval(this.interval);

            this.activeImageId += 1;
            if (this.activeImageId > this.imageCount - 1) {
                this.activeImageId = 0;
            }

            this.makeImageActive(this.activeImageId);
            this.startAutoPlay();
            _gaq.push(["_trackEvent", "Interaction", `Image carousel interaction NEXT (${this.activeImageId})`, document.URL, 0, false]);
        });
    }

    private makeImageActive(i: number) {
        this.activeImageId = i;
        this.showActiveImage();
    }

    private startAutoPlay() {
        const images: NodeListOf<HTMLElement> = document.querySelectorAll("[data-image-id]") as NodeListOf<HTMLElement>;
        const thumbs: NodeListOf<HTMLElement> = document.querySelectorAll("[data-thumb-id]") as NodeListOf<HTMLElement>;

        clearInterval(this.interval);

        this.interval = setInterval(() => {
            this.activeImageId += 1;
            if (this.activeImageId > images.length - 1) {
                this.activeImageId = 0;
            }

            this.makeImageActive(this.activeImageId);
        }, 5000);
    }
} 



// WEBPACK FOOTER //
// ./src/global/Carousel.ts